import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, IconButton, InputAdornment, TextField, Typography } from '@mui/material';

import { useT } from '@/hooks';

const MONO_FONT = 'var(--font-plex-mono), IBM Plex Mono, monospace';
const HEADING_FONT = 'var(--font-archivo), Archivo, sans-serif';

interface LimitPriceInputProps {
  limitPrice: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDecrease: () => void;
  onIncrease: () => void;
}

export function LimitPriceInput({
  limitPrice,
  onChange,
  onDecrease,
  onIncrease,
}: LimitPriceInputProps) {
  const { t } = useT();
  return (
    <Box sx={{ mb: 2.5 }}>
      <Typography
        sx={{
          fontFamily: HEADING_FONT,
          fontSize: '0.875rem',
          fontWeight: 600,
          color: 'text.primary',
          mb: 1.125,
        }}
      >
        {t('trade.limitPrice', { defaultValue: 'Limit Price' })}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton
          size="small"
          onClick={onDecrease}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '10px',
            color: 'text.secondary',
            width: 40,
            height: 40,
          }}
        >
          <RemoveIcon fontSize="small" />
        </IconButton>
        <TextField
          size="small"
          value={limitPrice}
          onChange={onChange}
          InputProps={{
            endAdornment: <InputAdornment position="end"></InputAdornment>,
          }}
          sx={{
            flex: 1,
            '& .MuiOutlinedInput-root': {
              bgcolor: 'background.default',
              borderRadius: '10px',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'divider',
            },
            '& input': {
              textAlign: 'center',
              fontFamily: MONO_FONT,
              fontWeight: 600,
              fontSize: '0.875rem',
              py: 1.125,
            },
          }}
        />
        <IconButton
          size="small"
          onClick={onIncrease}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '10px',
            color: 'text.secondary',
            width: 40,
            height: 40,
          }}
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
